import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { Grid, TextField, Typography, FormControl } from "@mui/material";
import axios from "axios";
import { useState, useRef, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { AlertMessage } from "../components/AlertMessage";
import { useAuthContext } from "../hooks/useAuthContext";
import "../assets/css/login.css";
import companyLogo from "../assets/images/Logo/logo.png";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import {
  config,
  loginAPI,
  resetPasswordEmailAPI,
  verifyOTPAPI,
  baseURL,
} from "../config";
import TwoFactorModal from "../components/TwoFactorModal";
import moment from "moment";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function Login() {
  const { dispatch } = useAuthContext();
  const [successLoginFlag, setSuccessLoginFlag] = React.useState(false);
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState("");
  const [show2FAModal, setShow2FAModal] = useState(false);
  const [twoFactorData, setTwoFactorData] = useState({
    requireEnrollment: false,
    require2FA: false,
    qrCode: "",
    secret: "",
    tempToken: "",
  });
  const [loading2FA, setLoading2FA] = useState(false);
  const [isForgotPin, setIsForgotPin] = React.useState(false);
  const [shakeInputs, setShakeInputs] = useState(false);

  const handleForgotPin = () => setIsForgotPin(!isForgotPin);

  const [otp, setOtp] = useState(new Array(4).fill(""));
  const navigate = useNavigate();
  const [errMessage, setErrMessage] = useState("");
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [isSendOTP, setIsSendOTP] = useState(false);
  const [intOTP, setOTP] = useState("");
  const [isVerifiedOTP, setIsVerifiedOTP] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      if (user.role_id === 36) navigate("/unauthorized");
      else if (user.role_id === 34 || user.role_id === 35) navigate("/dashboard");
    }
    return () => true;
  }, []);

  const validationSchema = Yup.object().shape({
    txtPassword: Yup.string().required("Password is required"),
    txtEmail: Yup.string().required("Email is required").email("Please enter valid email format"),
  });

  const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, handleSubmit, reset, formState } = useForm(formOptions);
  const { errors } = formState;

  const handleSendOTP = () => {
    setErrMessage("");
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(forgotPasswordEmail)) {
      setErrMessage("Please enter valid email");
      return false;
    }
    var reqData = JSON.stringify({ txtUsername: forgotPasswordEmail, intType: 5 });
    config.method = "post";
    config.url = resetPasswordEmailAPI;
    config.data = reqData;
    axios(config)
      .then((response) => {
        if (response.data.message === "Invalid Email") {
          setErrMessage(response.data.message);
        } else {
          setIsSendOTP(!isSendOTP);
        }
      })
      .catch((error) => {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        setErrMessage("Please Enter Valid Email ID");
      });
  };

  const handleVerifyOTP = () => {
    var reqData = JSON.stringify({ txtUsername: forgotPasswordEmail, intType: 9, intOTP: intOTP });
    config.method = "post";
    config.url = verifyOTPAPI;
    config.data = reqData;
    axios(config)
      .then((response) => {
        if (response.data.message === "Invalid Otp") {
          setErrMessage(response.data.message);
        } else {
          setIsVerifiedOTP(!isVerifiedOTP);
          setErrMessage("");
        }
      })
      .catch((error) => {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        setErrMessage("Invalid Username or Password");
      });
  };

  const handleChangesubmit = async (element, index) => {
    if (isNaN(element.value)) return false;
    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);
    if (element.nextSibling) element.nextSibling.focus();

    if (index === 3) {
      const pinarr = [...otp.map((d, idx) => (idx === index ? element.value : d))];
      let loginpin = "";
      pinarr.map((x) => { loginpin += x; });

      const data = { intPin: parseInt(loginpin), txtDate: moment().format("YYYY-MM-DD") };
      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = loginAPI;

      await axios(config)
        .then(async (response) => {
          if (response.data.require2FA || response.data.requireEnrollment) {
            setTwoFactorData({
              requireEnrollment: !!response.data.requireEnrollment,
              require2FA: !!response.data.require2FA,
              qrCode: response.data.qrCode || "",
              secret: response.data.secret || "",
              tempToken: response.data.tempToken || "",
            });
            setShow2FAModal(true);
            return;
          }

          if (response.data.message === "SUCCESS") {
            localStorage.removeItem("isProjectLoggedIn");
            localStorage.removeItem("projectID");
            localStorage.removeItem("projectAutoID");
            localStorage.removeItem("projectName");
            localStorage.removeItem("projectCheckInTime");
            localStorage.removeItem("userAttandenceLogin");
            if (
              response.data.result[1] &&
              response.data.result[1].working_hours === ""
            ) {
              if (!response.data.result[1].end_time || (response.data.result[1].end_time = "0000-00-00 00:00:00")) {
                localStorage.setItem("isProjectLoggedIn", true);
                localStorage.setItem("projectID", response.data.result[1].project_id ? response.data.result[1].project_id : 0);
                localStorage.setItem("projectAutoID", response.data.result[1].id ? response.data.result[1].id : 0);
                localStorage.setItem("projectName", response.data.result[1].project_name ? response.data.result[1].project_name : "");
                localStorage.setItem("projectCheckInTime", response.data.result[1].start_time ? response.data.result[1].start_time : "");
                localStorage.setItem("userAttandenceLogin", "true");
              }
            }
            setSuccessLoginFlag(true);
            let responseData = response.data.result[0];
            localStorage.setItem("user", JSON.stringify(responseData));
            dispatch({ type: "LOGIN", payload: "jsonData" });
            let pageURL = "/dashboard";
            if (responseData.role_id === 36) pageURL = "/unauthorized";
            window.location.href = pageURL;
          } else {
            setShakeInputs(true);
            setTimeout(() => setShakeInputs(false), 500);
            setOtp([...otp.map(() => "")]);
            setTimeout(() => { const f = document.querySelector(".pin-input-box"); if (f) f.focus(); }, 0);
          }
        })
        .catch((error) => {
          childRef.current.triggerAlert(JSON.stringify({ message: "Wrong credentials", messageType: "error" }));
          setShakeInputs(true);
          setTimeout(() => setShakeInputs(false), 500);
          setOtp([...otp.map(() => "")]);
          setTimeout(() => { const f = document.querySelector(".pin-input-box"); if (f) f.focus(); }, 0);
        });
    }
  };

  const handleVerify2FA = async (code) => {
    setLoading2FA(true);
    try {
      const endpoint = twoFactorData.requireEnrollment
        ? `${baseURL}/login/enroll-2fa`
        : `${baseURL}/login/verify-2fa`;
      const reqData = JSON.stringify({ tempToken: twoFactorData.tempToken, code, secret: twoFactorData.secret });
      config.method = "POST";
      config.data = reqData;
      config.url = endpoint;
      const response = await axios(config);
      if (response.data.success && response.data.result && response.data.result.length > 0) {
        setShow2FAModal(false);
        const finalUser = response.data.result[0];
        localStorage.setItem("user", JSON.stringify(finalUser));
        localStorage.removeItem("isProjectLoggedIn");
        localStorage.removeItem("projectID");
        localStorage.removeItem("projectAutoID");
        localStorage.removeItem("projectName");
        localStorage.removeItem("projectCheckInTime");
        localStorage.removeItem("userAttandenceLogin");
        dispatch({ type: "LOGIN", payload: "jsonData" });
        let pageURL = "/dashboard";
        if (finalUser.role_id === 36) pageURL = "/unauthorized";
        window.location.href = pageURL;
      }
    } finally {
      setLoading2FA(false);
    }
  };

  const childRef = useRef();

  return (
    <>
      <AlertMessage ref={childRef} />
      <Grid container className="full-height">
        <div className="blueprint-bg" />

        {/* ═══════════════════════════════════════
            LEFT PANE — Branding + Hub
            ═══════════════════════════════════════ */}
        <Grid item xs={12} lg={7.5} md={7.5} sm={7.5} className="left-branding-pane">

          {/* Logo */}
          <div className="logo-container-new">
            <img src={companyLogo} alt="KG Build Tech" className="logo-image-new" />
          </div>

          {/* Main content row */}
          <div className="left-pane-layout">

            {/* Branding text */}
            <div className="branding-text-column">
              <Typography variant="h1" className="main-title-new">
                <span className="navy">Build More.</span>
                <span className="blue">Manage Everything.</span>
              </Typography>
              <Typography className="main-desc-new">
                KG Build Tech's complete construction operations platform — projects, labour, procurement, payroll and approvals, all in one place.
              </Typography>
              {/* <div className="secure-badge-new">
                <svg width="13" height="15" viewBox="0 0 14 16" fill="currentColor">
                  <path d="M7 0L0 3v5c0 4.3 3 8.3 7 9.3 4-1 7-5 7-9.3V3L7 0zm0 13.9c-2.8-.7-4.9-3.7-4.9-6.9V4.6l4.9-2.1 4.9 2.1V7c0 3.2-2.1 6.2-4.9 6.9z"/>
                </svg>
                SECURE CONSTRUCTION MANAGEMENT PLATFORM
              </div> */}
            </div>

            {/* Operations Hub — circular nodes on orbit ring */}
            <div className="hub-column">
              <div className="hub-visual-container">

                {/* SVG orbit ring — viewBox 400×400, container 300×300px
                    Node circle = 64px CSS → center at 32px from edge
                    In SVG units: 32/300*400 = 42.7 → orbit r = 200-42.7 ≈ 157 */}
                <svg className="hub-svg-overlay" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="200" cy="200" r="157" className="hub-orbit-ring" />
                  <circle cx="200" cy="200" r="100" className="hub-orbit-ring-inner" />
                  <path id="orbit-travel" d="M200,43 A157,157 0 1,1 199.9,43 Z" fill="none" />
                  <circle className="pulse-dot" r="5">
                    <animateMotion dur="12s" repeatCount="indefinite">
                      <mpath href="#orbit-travel" />
                    </animateMotion>
                  </circle>
                  <circle className="pulse-dot" r="4" opacity="0.5">
                    <animateMotion dur="12s" begin="6s" repeatCount="indefinite">
                      <mpath href="#orbit-travel" />
                    </animateMotion>
                  </circle>
                </svg>

                {/* Center KG logo */}
                <div className="hub-center-symbol">
                  <img src={companyLogo} alt="KG Build Tech" />
                </div>

                {/* PROJECTS — top */}
                <div className="hub-node node-projects">
                  <div className="hub-node-circle">
                    {/* Construction/building icon */}
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <path d="M3 21h18M3 7v14M21 7v14M12 3L3 7h18l-9-4zM10 12h4v4h-4v-4z" />
                    </svg>
                  </div>
                  <span className="hub-node-label">Projects</span>
                </div>

                {/* LABOUR — left */}
                <div className="hub-node node-people">
                  <div className="hub-node-circle">
                    {/* Hard hat / worker icon */}
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <path d="M2 20h20M12 2a7 7 0 017 7H5a7 7 0 017-7z" />
                      <path d="M5 9v3a7 7 0 0014 0V9" />
                      <path d="M12 2v3M4 9h16" />
                    </svg>
                  </div>
                  <span className="hub-node-label">Labour</span>
                </div>

                {/* PROCUREMENT — right */}
                <div className="hub-node node-procurement">
                  <div className="hub-node-circle">
                    {/* Purchase order / box icon */}
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4H6zM3 6h18M16 10a4 4 0 01-8 0" />
                    </svg>
                  </div>
                  <span className="hub-node-label">Procurement</span>
                </div>

                {/* PAYROLL — bottom */}
                <div className="hub-node node-finance">
                  <div className="hub-node-circle">
                    {/* Payslip / salary icon */}
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <rect x="2" y="5" width="20" height="14" rx="2" />
                      <path d="M2 10h20M6 15h4M14 15h4" />
                    </svg>
                  </div>
                  <span className="hub-node-label">Payroll</span>
                </div>

              </div>
            </div>

          </div>


        </Grid>

        {/* ═══════════════════════════════════════
            RIGHT PANE — Login Card
            ═══════════════════════════════════════ */}
        <Grid item xs={12} lg={4.5} md={4.5} sm={4.5} className="right-login-pane">
          <div className="login-card-container">
            {successLoginFlag ? (
              <div className="login-card-new access-granted-box">
                <div className="success-checkmark">✓</div>
                <Typography variant="h5" fontWeight="700">Access Granted</Typography>
                <Typography variant="body2" color="textSecondary">Redirecting to workspace…</Typography>
              </div>
            ) : (
              <div className="login-card-new">

                {/* Header */}
                <div className="login-header-new">
                  <div className="security-icon-container">
                    <svg className="profile-icon-desktop" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z" />
                    </svg>
                    <img className="company-logo-mobile-tablet" src={companyLogo} alt="KG Logo" />
                  </div>
                  <Typography variant="h2" className="login-welcome-title">Welcome Back!</Typography>
                  <Typography className="login-welcome-desc">
                    Sign in to your KG Build Tech workspace
                  </Typography>
                  <div className="secure-signin-badge">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <rect x="3" y="11" width="18" height="11" rx="2" />
                      <path d="M7 11V7a5 5 0 0110 0v4" />
                    </svg>
                    SECURE SIGN IN
                  </div>
                </div>

                {/* PIN login (default state = isForgotPin is false initially but PIN entry) */}
                {!isForgotPin ? (
                  <>
                    <p className="login-form-title">Enter your 4-digit PIN to continue</p>
                    <div className={`pin-grid-container${shakeInputs ? " shake-error" : ""}`}>
                      {otp.map((data, index) => (
                        <input
                          key={index}
                          className="pin-input-box"
                          type="password"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          maxLength="1"
                          value={data}
                          onChange={(e) => handleChangesubmit(e.target, index)}
                          onFocus={(e) => e.target.select()}
                          onKeyDown={(e) => {
                            if (e.key === "Backspace" && index > 0) {
                              setTimeout(() => {
                                if (!e.target.value) {
                                  const prev = document.querySelectorAll(".pin-input-box")[index - 1];
                                  if (prev) prev.focus();
                                }
                              }, 0);
                            }
                          }}
                        />
                      ))}
                    </div>
                    <FormControl sx={{ m: 0, width: "100%" }}>
                      <Grid container direction="column" gap={2}>
                        <LoadingButton
                          className="btn-primary-new"
                          size="large"
                          variant="contained"
                          disabled={formState.isSubmitting || otp.includes("")}
                        >
                          Sign In <span className="arrow-icon">→</span>
                        </LoadingButton>
                        <Grid item textAlign="center">
                          <span onClick={handleForgotPin} className="pointer-link">
                            Forgot PIN?
                          </span>
                        </Grid>
                      </Grid>
                    </FormControl>
                  </>
                ) : isSendOTP ? (
                  /* OTP verification */
                  <>
                    <div className="login-form-title">Verify your email</div>
                    <Typography className="login-welcome-desc" style={{ textAlign: "center", marginBottom: "1.5rem" }}>
                      Enter the verification code sent to your registered email.
                    </Typography>
                    <Grid>
                      <TextField
                        className="mui-text-field-custom"
                        name="txtOTP"
                        type="text"
                        label="Verification Code"
                        fullWidth
                        value={intOTP}
                        onChange={(e) => setOTP(e.target.value)}
                        error={!!errMessage}
                        helperText={errMessage}
                      />
                    </Grid>
                    <FormControl sx={{ m: 0, width: "100%" }}>
                      <Grid container direction="column" gap={2}>
                        <LoadingButton className="btn-primary-new" size="large" variant="contained" onClick={handleVerifyOTP}>
                          Verify OTP
                        </LoadingButton>
                        <Grid item textAlign="center">
                          <span onClick={() => setIsSendOTP(false)} className="pointer-link">Change email</span>
                        </Grid>
                      </Grid>
                    </FormControl>
                  </>
                ) : (
                  /* Send OTP / forgot PIN */
                  <>
                    <div className="login-form-title">Reset your PIN</div>
                    <Typography className="login-welcome-desc" style={{ textAlign: "center", marginBottom: "1.5rem" }}>
                      Enter your registered email to receive a verification code.
                    </Typography>
                    <Grid>
                      <TextField
                        className="mui-text-field-custom"
                        name="txtEmail"
                        type="email"
                        label="Email Address"
                        fullWidth
                        value={forgotPasswordEmail}
                        onChange={(e) => setForgotPasswordEmail(e.target.value)}
                        error={!!errMessage}
                        helperText={errMessage}
                      />
                    </Grid>
                    <FormControl sx={{ m: 0, width: "100%", marginTop: "0.5rem" }}>
                      <Grid container direction="column" gap={2}>
                        <LoadingButton className="btn-primary-new" size="large" variant="contained" onClick={handleSendOTP}>
                          Send OTP <span className="arrow-icon">→</span>
                        </LoadingButton>
                        <Grid item textAlign="center">
                          <span onClick={handleForgotPin} className="pointer-link">Cancel</span>
                        </Grid>
                      </Grid>
                    </FormControl>
                  </>
                )}

              </div>
            )}
          </div>
        </Grid>
      </Grid>

      <TwoFactorModal
        open={show2FAModal}
        onClose={() => setShow2FAModal(false)}
        requireEnrollment={twoFactorData.requireEnrollment}
        require2FA={twoFactorData.require2FA}
        qrCode={twoFactorData.qrCode}
        secret={twoFactorData.secret}
        onVerify={handleVerify2FA}
        loading={loading2FA}
      />
    </>
  );
}
